// 画像生成に使う AI モデルの単一の正。
//
// バナー広告 / カルーセル / 素材制作 / 漫画広告 / ムービー(β)の絵コンテは
// 以前それぞれ独立に「AIモデル」セレクタ（gpt-image-2 / nanobanana2）を持っていたが、
// 実運用では gpt-image-2 一択で足りるため UI ごと廃止し、この定数に集約した。
//
// 注意: backend の同期エンドポイント（ImageGenerationController）は model 省略時に
// nanobanana2 へフォールバックする歴史的既定を持つ。既定側も gpt-image-2 に揃えたが、
// フロントからは常にこの値を明示送信して二重に担保する。
// モデルを切り替えるときはここ 1 箇所を変える。
export const IMAGE_GENERATION_MODEL = 'gpt-image-2';

// バナー広告ページでユーザーが選べるモデル。既定は GPT Image 2.6（master と同じ選択肢）。
export const BANNER_IMAGE_MODEL_OPTIONS = [
  { value: 'gpt-image-2.6-flare', label: 'GPT Image 2.6（標準）' },
  { value: 'gpt-image-2', label: 'GPT Image 2' },
  { value: 'nanobanana2', label: 'Nano Banana 2.1' }, // 値は既存データ互換のため据え置き。実モデルは backend GeminiImageModel::CURRENT_FLASH
] as const;

export type BannerImageModel = (typeof BANNER_IMAGE_MODEL_OPTIONS)[number]['value'];

export const DEFAULT_BANNER_IMAGE_MODEL: BannerImageModel = 'gpt-image-2.6-flare';
